import React from 'react';
import PropTypes from 'prop-types';
import { isEmpty } from 'ramda';
import { TextField, Button, Typography } from '@material-ui/core';
import { useFormik } from 'formik';
import { useTranslation } from 'react-i18next';
import { validationSchema, initialValues } from 'forms/forgotPasswordForm';

import useStyles from './useStyles';

const ForgotPasswordForm = props => {
  const { t } = useTranslation();
  const classes = useStyles();

  const { onSubmit } = props;

  const formik = useFormik({
    validationSchema,
    initialValues,
    onSubmit,
  });

  const { errors, values, handleChange, handleSubmit, isSubmitting, handleBlur, touched } = formik;

  const isAbleToSubmit = !isSubmitting && isEmpty(errors);

  return (
    <div className={classes.paper}>
      <Typography variant="h1">{t('components.ForgotPasswordForm.header')}</Typography>
      <form noValidate onSubmit={handleSubmit}>
        <TextField
          error={touched.email && Boolean(errors.email)}
          helperText={touched.email && t(errors.email)}
          variant="outlined"
          id="email"
          name="email"
          type="email"
          placeholder={t('components.ForgotPasswordForm.email')}
          autoComplete="email"
          onChange={handleChange}
          onBlur={handleBlur}
          value={values.email}
          className={classes.field}
        />
        <Button className={classes.button} type="submit" disabled={!isAbleToSubmit}>
          {t('components.ForgotPasswordForm.button')}
        </Button>
      </form>
    </div>
  );
};

ForgotPasswordForm.propTypes = {
  onSubmit: PropTypes.func.isRequired,
};

export default ForgotPasswordForm;



// WEBPACK FOOTER //
// ./src/sharedComponents/ForgotPasswordForm/ForgotPasswordForm.js